import { Notification } from "api/types/alerts";
import GenericDialog from "./generic";
import { useTranslation } from "react-i18next";
import { formatDate, minutesToTimeString } from "util/datelib";
import LabeledField from "providers/labeledField";
    
const AlertNotificationsDialog = (props: {
  isOpen: boolean;
  onClose: () => void;
  notifications: Notification[];
}) => {
  const { isOpen, onClose, notifications } = props;
  const { t } = useTranslation();

  return (
    <GenericDialog
      isOpen={isOpen}
      onExit={onClose}
      onOk={onClose}
      title={t("dialog.alerts.notifications.title")}
      size="lg"
    >
      <div className="max-h-96 overflow-y-auto">
        {notifications.length === 0 ? (
          <div className="text-center py-8 text-secondary">
            {t("dialog.alerts.notifications.noNotifications")}
          </div>
        ) : (
          <div className="space-y-4">
            {notifications.map((notification, index) => (
              <div key={index} className="rounded-lg p-4 bg-background-800">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <LabeledField
                    id={`notification-${index}-created`}
                    label={t("dialog.alerts.notifications.created")}
                    textColor="secondary"
                  >
                    <div className="text-txt-md text-primary">{formatDate(notification.created, 'lastcomms')}</div>
                  </LabeledField>
                  <LabeledField
                    id={`notification-${index}-type`}
                    label={t("dialog.alerts.notifications.type")}
                    textColor="secondary"
                  >
                    <div className="text-txt-md text-primary">{notification.type.toUpperCase() || '-'}</div>
                  </LabeledField>
                  <LabeledField
                    id={`notification-${index}-user`}
                    label={t("dialog.alerts.notifications.user")}
                    textColor="secondary"
                  >
                    <div className="text-txt-md text-primary">{notification.user || '-'}</div>
                  </LabeledField>
                  <LabeledField
                    id={`notification-${index}-username`}
                    label={t("dialog.alerts.notifications.username")}
                    textColor="secondary"
                  >
                    <div className="text-txt-md text-primary">{notification.username || '-'}</div>
                  </LabeledField>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </GenericDialog>
  );
};

export default AlertNotificationsDialog;
